import { inject } from "@angular/core";
import { HttpInterceptorFn, HttpErrorResponse } from "@angular/common/http";
import { NbToastrService } from "@nebular/theme";
import { catchError, throwError } from "rxjs";

/**
 * Centralized error surface for failed HTTP calls. Surfaces a toast for
 * 4xx/5xx responses and re-throws so per-component handlers can still
 * react. Deliberately does NOT log the raw response body — per
 * security rules PHI must never be logged.
 */
const errorMessageFor = (status: number): string => {
  if (status === 401) return "Session expired. Please sign in again.";
  if (status === 403) return "You do not have access to this resource.";
  if (status >= 500) return "Server error. Please try again shortly.";
  return "Request could not be completed.";
};

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(NbToastrService);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err instanceof HttpErrorResponse) {
        const title = `Request failed (${err.status || "network"})`;
        const message = errorMessageFor(err.status);
        toastr.danger(message, title);
      }
      return throwError(() => err);
    }),
  );
};
